
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./App": () => {
return Promise.all(/*  | __federation_expose_App */ [__webpack_require__.e("787"), __webpack_require__.e("728"), __webpack_require__.e("499"), __webpack_require__.e("362")]).then(() => (() => (__webpack_require__(465))));
},
"./Receivable": () => {
return Promise.all(/*  | __federation_expose_Receivable */ [__webpack_require__.e("787"), __webpack_require__.e("728"), __webpack_require__.e("503")]).then(() => (() => (__webpack_require__(4537))));
},
"./Insurance": () => {
return Promise.all(/*  | __federation_expose_Insurance */ [__webpack_require__.e("787"), __webpack_require__.e("728"), __webpack_require__.e("365")]).then(() => (() => (__webpack_require__(4878))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };